import React from 'react';
import { connect } from 'react-redux';
import './DirectoryTeamsFilter.scss';
import _ from 'lodash';
import ComboBox from '../../../../../components/ComboBox';
import AnalyticsLogger from '../../../../../helpers/analytics/analyticsLogger';
import DataSource from '../../../../../dao/DataSource/DataSource';
import BaseComponent from '../../../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import { teamAssignedProjects } from '../../../../../helpers/teamAssignedProjects';

const teamDescriptor = { team: { lead_user: {}, users: {}, markets: { company: {}, vendor_users: { role: {} }, users: { role: {} } } } };
class DirectoryTeamsFilter extends BaseComponent {
  constructor(props) {

    super(props);
    this.state = {
      markets: null,
      selectedMarkets: null,
      team: { name: '', logo: null, markets: [], lead_user: null },
      selectedMarket:
        props.selectedFilters && props.selectedFilters.market
          ? props.selectedFilters.market
          : null,
      selectedTeamLead:
        props.selectedFilters && props.selectedFilters.lead
          ? props.selectedFilters.lead
          : null,
    };

   // this.setMarketUsers = this.setMarketUsers.bind(this)
    this.marketsEqual = this.marketsEqual.bind(this);
    this.changeTeamName = this.changeTeamName.bind(this);

  }

  handleCompanyRetrieval(company) {
    if (company) {
      this.setState({ company, markets: company.markets });
    }
  }
  componentWillUnmount() {
    if (this.companyDataSource) {
      this.companyDataSource.release();
      this.companyDataSource = null;
    }
    if (this.teamDataSource) {
      this.teamDataSource.release();
      this.teamDataSource = null;
    }
  }

  componentDidMount() {
    this.teamDataSource = new DataSource('Team', this.props.teamId, teamDescriptor, this.handleTeamRetrieval);
    this.teamDataSource.get();

    const currentRole = this.props.currentUser ? this.props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.companyDataSource = new DataSource('Company', this.props.currentCompany.id, {
      company: {
        markets: {
          users: { additionalFields: ['profile_image'], role: {} },
          vendor_users: { additionalFields: ['profile_image'], role: {} },
        },
      },
    },
      this.handleCompanyRetrieval);
    this.companyDataSource.get();
  }

  changeTeamName(e) {
    let team = this.state.team;
    team.name = e.target.value;
    let active = this.state.active;
    if (team.markets && team.markets.length > 0 && team.name) {
      active = true;
    }
    this.setState({ team, active, nameChanged: true });
  }

  marketsEqual(markets1, markets2) {
    if (!markets1 || !markets2) {
      return false;
    }
    if (markets1.length != markets2.length) {
      return false;
    }
    else {
      markets2.forEach(market2 => {
        if (!markets1.find(market1 => { return market1.id == market2.id; })) {
          return false;
        }
      });
      return true;
    }
  }

  handleTeamRetrieval(team, action, acData, fetchedData) {
    if (fetchedData) {
      this.setState({ team: fetchedData, updatedTeamUsers: null });
    }
    else {
      const assigned = teamAssignedProjects(team);
      let selectedProjects = assigned.length ? assigned.map(project => { return project.id; }) : [];
      this.setState({ selectedProjects, team, originalMarkets: team.markets ? team.markets.map(m => { return m; }) : [] });
      if (!this.state.originalTeam) {
        this.setState({ originalTeam: _.cloneDeep(team) });
      }
      this.setMarketUsers(team.markets);
    }
  }

  componentDidUpdate(prevProps) {
    const nextProps = this.props;
    if (
      nextProps.selectedFilters != prevProps.selectedFilters &&
      nextProps.selectedFilters
    ) {
      this.setState({
        selectedMarket:
          nextProps.selectedFilters && nextProps.selectedFilters.market
            ? nextProps.selectedFilters.market
            : null,
      });
    }
  }

  handleCloseMenu() {
    if (this.state.menu) {
      this.setState({ menu: null, displayMenu: '' });
    }
  }

  // handleMarketChange(type, option) {
  //   console.log(this.props.newUsers.filter(user => console.log(user)))
  //   const { handleMarketSelection } = this.props
  //   if (handleMarketSelection) {
  //     this.setState({
  //       selectedMarket: type
  //     })
  //     handleMarketSelection(type == 'allMarkets' ? null : type)
  //   }
  // }

  handleMarketChange(markets) {
    // let team = this.state.team
    // team.markets = markets.map(market => {
    //   return market.market
    // })
    // const marketsItems = team.markets.map(m => {
    //   m.selected = true
    //   return m
    // });

    const { handleMarketSelection } = this.props;
    if (handleMarketSelection) {
      this.setState({
        selectedMarket: markets,
      });
      handleMarketSelection(markets);
    }

  }

  handleLeadSelection(lead) {
    const { handleLeadSelection } = this.props;
    if (handleLeadSelection) {
      this.setState({
        selectedTeamLead: lead,
      });
      handleLeadSelection(lead);
    }
  }

  render() {
    const { markets, selectedTeamLead, selectedMarket } = this.state;

    let marketsList = [];

    if (markets) {
      markets.forEach(market => {
        let marketOption = {
          type: market.id,
          id: market.id,
          name: market.name,
          selected: false,
          market: market,
        };
        marketsList.push(marketOption);
      });
    }
    if(selectedMarket){

      marketsList.forEach(m => {
        if(selectedMarket.some(s => m.id == s.id)) {
          m.selected = true;
        }
        
      });
    }

    let users = [];
    if (markets) {
      markets.forEach(market => {
        if (market.users) {
          market.users.forEach(user => {
            if (!users.find(u => { return user.id == u.id; })) {
              if (!user.suspended && (user.role.name == 'admin' || user.role.name == 'editor')) {
                users.push({ type: user.id, name: user.name, id: user.id });
              }
            }
          });
        }
      });
    }    
    
    if(selectedTeamLead){

      users.forEach(m => {
        if(selectedTeamLead.some(s => m.id == s.id)) {
          m.selected = true;
        }
        
      });
    }

    return (
      <div className='team-container'>
        <div className='team-info'>
          <p className='caption'>MARKETS</p>
          <div className="team-combo-box">
            <ComboBox
              key={'marketPicker'}
              id={'marketPicker'}
              options={marketsList }
              currentOption={selectedMarket}
              hasBorder={false}
              underlined={false}
              height={31}
              multiSelect={true} 
              width={238}
              menuHeight={120}
              displayFontStyle={{ fontSize: '14px' }}
              handleMultiMenuSelection={this.handleMarketChange}
              
            />
          </div>

          <p className='caption'>TEAM LEAD</p>
          <div className="team-combo-box">

            <ComboBox
              key={'team-user'}
              id={'team-user'}
              options={users}
              currentOption={selectedTeamLead}
              hasBorder={false}
              underlined={false}
              height={31}
              multiSelect={true} 
              width={238}
              menuHeight={120}
              displayFontStyle={{ fontSize: '14px' }}
              handleMultiMenuSelection={this.handleLeadSelection}
            />
          </div>

        </div>

      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
    activitiesList: state.activityLogs.activitiesList,
    userRoles: state.new_users.userRoles,
    newUsers: state.new_users,
  };
};

export default connect(mapStateToProps)(DirectoryTeamsFilter);



// WEBPACK FOOTER //
// ./src/containers/Directory/DirectoryTeamsSearchFilter/DirectoryTeamsFilterPopout/DirectoryTeamsFilter/index.js